import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { ClusterData, EntryData, ProviderData, TedDomain } from '../entry/structure-data.models';

export const EntryActions = createActionGroup({
    source: 'Entry Page',
    events: {
      'Set Current Accession': props<{ accession: string }>(),
      'Set Current UniprotAccession': props<{ uniprotAccession: string }>(),
      'Set Current IsUniprot': props<{ isUniProt: boolean }>(),
      'Set Current Provider': props<{ providerData: ProviderData }>(),
      'Get Entry Data': emptyProps(),
      'Get Entry Data Success': props<{ entryData: EntryData }>(),
      'Get Entry Data Failure': emptyProps(),
      'Get CSV Data': emptyProps(),
      'Get CSV Data Success': props<{ csvAmData: string }>(),
      'Get CSV Data Failure': emptyProps(),
      'Get TedDomain Data': emptyProps(),
      'Get TedDomainData Success': props<{ tedDomainData: TedDomain[] }>(),
      'Get TedDomainData Failure': emptyProps(),
      'Get Clustermmseq Data': emptyProps(),
      'Get Clustermmseq Success': props<{ clustermmseqData: ClusterData }>(),
      'Get Clustermmseq Failure': emptyProps(),
      'Get Clusterfoldseek Data': emptyProps(),
      'Get Clusterfoldseek Success': props<{ clusterfoldseekData: ClusterData }>(),
      'Get Clusterfoldseek Failure': emptyProps(),
      'Get Uniprot Data': emptyProps(),
      'Get Uniprot Data Success': props<{ uniprotData: any }>(),
      'Get Uniprot Data Failure': emptyProps(),
    },
 });
  
